<div class="content">
  <div class="document" *ngFor="let reminder of reminders">
    <div class="document-content">
      <div class="document-avatar"[style.background-color]="getColorFromName(reminder.title)">{{getInitial(reminder.title)}}</div>
      <div class="document-text">
        <div class="document-name">{{getReminderTitle()}}</div>
        <div class="document-desc">{{reminder.text}}</div>
      </div>
    </div>
    <div class="action-buttons">
      <button  (click)="editReminder(reminder)" mat-icon-button >
        <mat-icon>edit_outline</mat-icon>
      </button>
      <button  (click)="onDelete(reminder)" mat-icon-button >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
</div>
<div class="add-new-container">
  <button mat-fab color="primary" (click)="editReminder(null)">
 + Add new
  </button>
</div>